import React from 'react';

import { ActionIcon, Box, NumberInput, createStyles } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { IconTrash } from '@tabler/icons-react';
import CategoryAutoComplete, {
  RevenueCategoryAutoCompleteValue,
} from 'components/form-fields/auto-complete-fields/RevenueCategoryAutoComplete';

import { PackageRevenueCategoriesFormValues } from '../RevenueCategorizationDrawer';

interface IPackageRevenueCategoryRowProps {
  permission: boolean;
  index: number;
  form: UseFormReturnType<PackageRevenueCategoriesFormValues>;
}

const useStyles = createStyles(theme => ({
  row: {
    display: 'grid',
    gridTemplateColumns: 'auto auto min-content',
    gridTemplateRows: 'auto',
    gap: theme.spacing.sm,
  },
}));

const PackageRevenueCategoryRow = ({
  permission,
  index,
  form,
}: IPackageRevenueCategoryRowProps): JSX.Element => {
  const { classes } = useStyles();
  const handleCategoryChange = (item: RevenueCategoryAutoCompleteValue | null): void => {
    const newValue = {
      revenueCategoryId: item ? item.revenueCategoryId : '',
      value: item ? item.revenueCategoryId : '',
      label: item ? item.label : '',
    };
    form.setFieldValue(`packageRevenueCategories.${index}.revenueCategory`, newValue);
  };

  const handlerevenueFractionChange = (rate: number): void => {
    form.setFieldValue(`packageRevenueCategories.${index}.revenueFraction`, rate);
  };

  return (
    <Box className={classes.row} key={`key-${index}`}>
      <CategoryAutoComplete
        zIndex={99999}
        required
        disabled={!permission}
        sx={{ flex: 1 }}
        value={form.values.packageRevenueCategories[index].revenueCategory}
        onChange={handleCategoryChange}
        disinclude={form.values.packageRevenueCategories.map(
          packageCategory => packageCategory.revenueCategory.revenueCategoryId,
        )}
      />
      <NumberInput
        required
        parser={(value: any) => value.replace(/\$\s?|(,*)/g, '')}
        formatter={(value: any) =>
          !Number.isNaN(parseFloat(value))
            ? `${value} %`.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
            : ''
        }
        min={0.5}
        max={100}
        precision={2}
        step={0.5}
        onChange={handlerevenueFractionChange}
        value={form.values.packageRevenueCategories[index].revenueFraction}
        disabled={!permission}
        key={`key-${index}`}
      />
      <ActionIcon
        onClick={() => form.removeListItem('packageRevenueCategories', index)}
        disabled={!permission}
      >
        <IconTrash size='1.2rem' />
      </ActionIcon>
    </Box>
  );
};

export default PackageRevenueCategoryRow;
